import { ColumnSelect, ColumnSelectOption } from 'lib/components/ColumnSelect';
import { SyncAttemptStatus } from 'lib/types/syncAttempt';
import { SHOW_ALL_OPTION_VALUE } from './helpers';

export enum SyncStatusFilterValue {
  SUCCESS = 'Success',
  IN_PROGRESS = 'In Progress',
  BLOCKED = 'Blocked',
  ERROR = 'Error'
}

export const SyncStatusToFilterValueMap: Record<
  SyncAttemptStatus,
  SyncStatusFilterValue
> = {
  [SyncAttemptStatus.SUCCESS]: SyncStatusFilterValue.SUCCESS,
  [SyncAttemptStatus.IN_PROGRESS]: SyncStatusFilterValue.IN_PROGRESS,
  [SyncAttemptStatus.SKIPPED]: SyncStatusFilterValue.BLOCKED,
  [SyncAttemptStatus.BAD_REQUEST]: SyncStatusFilterValue.BLOCKED,
  [SyncAttemptStatus.INTERNAL_ERROR]: SyncStatusFilterValue.ERROR,
  [SyncAttemptStatus.EXTERNAL_ERROR]: SyncStatusFilterValue.ERROR
};

export const FilterValueToSyncStatusMap: Record<
  SyncStatusFilterValue,
  SyncAttemptStatus[]
> = {
  [SyncStatusFilterValue.SUCCESS]: [SyncAttemptStatus.SUCCESS],
  [SyncStatusFilterValue.IN_PROGRESS]: [SyncAttemptStatus.IN_PROGRESS],
  [SyncStatusFilterValue.BLOCKED]: [
    SyncAttemptStatus.SKIPPED,
    SyncAttemptStatus.BAD_REQUEST
  ],
  [SyncStatusFilterValue.ERROR]: [
    SyncAttemptStatus.INTERNAL_ERROR,
    SyncAttemptStatus.EXTERNAL_ERROR
  ]
};

type SyncStatusFilterProps = {
  value: SyncStatusFilterValue | typeof SHOW_ALL_OPTION_VALUE;
  onChange: (
    value: SyncStatusFilterValue | typeof SHOW_ALL_OPTION_VALUE
  ) => void;
};

export function SyncStatusFilter({ value, onChange }: SyncStatusFilterProps) {
  const options: ColumnSelectOption<
    SyncStatusFilterValue | typeof SHOW_ALL_OPTION_VALUE
  >[] = [
    {
      value: SHOW_ALL_OPTION_VALUE,
      label: 'Show All'
    },
    ...Object.values(SyncStatusFilterValue).map(status => {
      return {
        value: status,
        label: status
      };
    })
  ];
  return (
    <ColumnSelect<SyncStatusFilterValue | typeof SHOW_ALL_OPTION_VALUE>
      id="sync-status-filter"
      labelText="Sync Status"
      value={value ?? SHOW_ALL_OPTION_VALUE}
      onChange={onChange}
      options={options}
      allowUndefined
    />
  );
}
